module.exports = __webpack_public_path__ + "img/big_11B25_yellow.d7508ad6.png";